enum ContextActionTypesEnum {
    SetUser = 'SET_USER',
}

export default ContextActionTypesEnum;